import { createFakeInsight } from 'helpers/insightHelpers'
import { Insight as InsightType, InsightReward } from 'interfaces/insights'

// Regular insights for styleguide

const REWARD_CURRENCY: InsightReward = {
  type: 'currency',
  value: 15,
  text: 'annotation text',
}

export const REGULAR_INSIGHTS: InsightType[] = [
  createFakeInsight<InsightType>({
    text: 'Look at you! A too-much-spending person in the flesh!',
    reward: {
      type: 'currency',
      value: 15,
      text: 'annotation text',
    },
  }),
  createFakeInsight<InsightType>({
    text: 'On average, you spend $200 more on groceries than your peers. We have a credit card with great rewards for purchases at grocery stores',
    reward: {
      type: 'percentage',
      value: 10,
      text: '',
    },
  }),
  createFakeInsight<InsightType>({
    text: 'Here is an example of insight. It is really helpful.',
  }),
]

// Top opportunities for styleguide

const HIGHLIGHT: Partial<InsightType> = {
  is_dismissed: false,
  is_sponsored: false,
  placement: 'dashboard_opportunities',
  title: '',
  type: 'insight_with_successor',
  text: 'Status analyzes your finances to help you save and earn money. Link your accounts to get started.',
  match: {
    value: 100,
    text: '',
  },
  cta: {
    dismiss: {},
    add_account: {},
  },
}

export const HIGHLIGHTS = [
  createFakeInsight({
    ...HIGHLIGHT,
    style: { status: 'warning', appearance: 'default' },
    is_new: true,
    type: 'zero_state',
  }),
  createFakeInsight({
    ...HIGHLIGHT,
    is_new: false,
  }),
  createFakeInsight({
    ...HIGHLIGHT,
    is_new: true,
    is_sponsored: true,
    reward: REWARD_CURRENCY,
  }),
]
